import { ICodReview } from './cod-review.interface';

export interface ICreditReview extends ICodReview {
    financialAdjustment: number;
}
